import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Image from "react-bootstrap/Image";
import { isMobileOrTablet } from "../Utils";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu/index.js";
import "./Navbar.css";

export default function HeaderNav({  }) {
  const [showModal, setShowModal] = useState(false);
  const [navbar, setNavbar] = useState(false);
  const isMobileOrTabletDevice = isMobileOrTablet();
 
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const NavbarElement = document.getElementById("Navbar");

      if (currentScrollPos === 0) {
        setNavbar(false);
        NavbarElement.classList.remove("navbarTransition");
      } else {
        if (prevScrollPos > currentScrollPos) {
          setNavbar(true);
        } else if (prevScrollPos < currentScrollPos) {
          if (!isMobileOrTabletDevice) {
            setNavbar(true);
          } else {
            setNavbar(false);
            NavbarElement.classList.add("navbarTransition");
          }
        }
      }
      prevScrollPos = currentScrollPos;
    };

    let prevScrollPos = window.scrollY;

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isMobileOrTabletDevice]);

  return (
    <Container className="navbar-cont">
      <Navbar
        id="Navbar"
        collapseOnSelect
        fixed="top"
        bg="dark"
        className={navbar ? "navbar active" : "navbar"}
        variant="dark"
        expand="lg"
      >
        <Container>
          <Navbar.Brand className="d-flex">
            <a href="https://celligence.com/">
              <Image
                src={`${process.env.REACT_APP_CDN_IMAGES}celligence-logo.webp`}
                height="40px"
                width="170px"
                alt="Celligence Logo"
                className="celligenceLogo"
              />
            </a>
            <UserWayAccessibilityMenu color="white" width={30} height={30} />
          </Navbar.Brand>
        </Container>
      </Navbar>
     
    </Container>
  );
}